export default {
  en: {
    currentOrder: 'Current order',
    orderNumber: 'OD {number}',
    status: 'Status',
    orderTotal: 'Order total',
    itemCount: 'Items',
    restaurant: 'Restaurant',
    restaurantAddress: 'Restaurant address',
    deliveryShort: 'Delivery',
    deliveryAddress: 'Delivery address',
    onMap: 'On map',
    mapUnavailable: 'Map coordinates are not available',
    reject: 'Decline',
    acceptOrder: 'Accept order',
    pickupTime: 'Pickup time',
    timeRemaining: 'Remaining',
    arrivedAtRestaurant: 'I arrived at the restaurant',
    orderPickedUp: 'Order received',
    client: 'Client',
    deliveryTime: 'Delivery time',
    arrivedAtClient: 'I arrived at the client',
    orderDelivered: 'Order delivered',
    noActiveOrder: 'No active orders',
    activeOrders: 'Active orders',
    completedOrders: 'Completed',
    selectOrderHint: 'Open an order from the Orders tab',
    errorLoadOrder: 'Could not load order',
    errorLoadOrders: 'Could not load orders',
    errorActionFailed: 'Action failed',
    amountDue: 'Collect from client',
    payToCourier: 'Cash on delivery',
    confirmPaymentReceived: 'Confirm you received {amount} from the client',
    paymentReceived: 'Payment received',
    paymentNotReceived: 'Mark payment as received to complete delivery',
  },
  ru: {
    currentOrder: 'Текущий заказ',
    orderNumber: 'OD {number}',
    status: 'Статус',
    orderTotal: 'Сумма заказа',
    itemCount: 'Позиций',
    restaurant: 'Ресторан',
    restaurantAddress: 'Адрес ресторана',
    deliveryShort: 'Доставка',
    deliveryAddress: 'Адрес доставки',
    onMap: 'На карте',
    mapUnavailable: 'Координаты для карты недоступны',
    reject: 'Отказ',
    acceptOrder: 'Принять заказ',
    pickupTime: 'Время сбора заказа',
    timeRemaining: 'Осталось',
    arrivedAtRestaurant: 'Я прибыл в ресторан',
    orderPickedUp: 'Заказ получил',
    client: 'Клиент',
    deliveryTime: 'Время доставки',
    arrivedAtClient: 'Я прибыл к клиенту',
    orderDelivered: 'Заказ доставил',
    noActiveOrder: 'Нет активных заказов',
    activeOrders: 'Активные заказы',
    completedOrders: 'Выполненные заказы',
    selectOrderHint: 'Выберите заказ во вкладке «Заказы»',
    errorLoadOrder: 'Не удалось загрузить заказ',
    errorLoadOrders: 'Не удалось загрузить заказы',
    errorActionFailed: 'Не удалось выполнить действие',
    amountDue: 'К получению',
    payToCourier: 'Оплата наличными курьеру',
    confirmPaymentReceived: 'Подтвердите, что получили {amount} от клиента',
    paymentReceived: 'Оплата получена',
    paymentNotReceived: 'Чтобы завершить доставку, отметьте получение оплаты',
  },
}
